import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.72 13.69L5.41 20H9V22H2V15H4V18.59L10.31 12.28L11.72 13.69ZM20 2H15V4H18.59L12.28 10.31L13.69 11.72L20 5.41V9H22V2H20Z" fill={ fill || 'currentColor' } />
    </svg>
);
